import React from 'react';

import PropTypes from 'prop-types';

import Auth0Session from 'contexts/AuthSessionProvider/Auth0Session';

const AuthSessionProvider = ({ children }) => <Auth0Session>{children}</Auth0Session>;

AuthSessionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthSessionProvider;
